// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getWeek as fn } from "../getWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getWeek = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getWeek;
